import { render, staticRenderFns } from "./ImgSlider.vue?vue&type=template&id=d5eb2dd8"
import script from "./ImgSlider.vue?vue&type=script&lang=js"
export * from "./ImgSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports